import styled from "styled-components";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import useCart from "../../hooks/cart/useCart";
import Modal from "../../components/common/Modal";
import CartItem from "../../components/cart/CartItem";

function  Cart(){
    const {isOpenModal, modal, cartItemList, selectedItemList, onCartItemClickHandler, selectedTotalAmount, onPayClickHandler
    } = useCart();

    const renderCartList = () => {
        if(cartItemList.length){
            return cartItemList.map((item, index) => {
                const totalAmount = item.class.amount + item.option_list.reduce((sum, item) => sum + item.amount, 0);
                return <CartItem 
                    key={item.id} 
                    id={item.id}
                    thumbnailImg={item.thumbnail_img}
                    title={item.title}
                    classData={item.class}
                    optionList={item.option_list}
                    totalAmount={totalAmount}
                    onCartItemClickHandler={onCartItemClickHandler}
                    checked={selectedItemList.includes(item.id)}
                />
            })
        }
        return null;
    }

    return(
        <Container>
            <Modal isOpen={isOpenModal} title={modal.title} content={modal.content} onClose={modal.onConfirmClickHandler}/>
            <Header />
            <div className="inner">
                <Content>
                    <Product>
                        <Label>PRODUCT</Label>
                        <HorizontalSprator />
                        {renderCartList()}
                        <HorizontalSprator />
                        <Total><div>TOTAL</div><div>{selectedTotalAmount.toLocaleString()}원</div></Total>
                        {selectedTotalAmount ? <Button onClick={onPayClickHandler}>결제 하기</Button> : null}
                    </Product>
                </Content>
            </div>
            <Footer />
        </Container>
    )
}

const Container = styled.div`
    min-width: 100vw;
    min-height: 100vh;
`

const Content = styled.div`
    padding-top: 120px;
    padding-bottom: 120px;
`

const Product = styled.div`
    display: flex;
    flex-direction: column;
    padding: 30px;
    gap: 20px;
    border-radius: 20px;
    background-color: #EBEBEB;
`

const Label = styled.div`
    color: #222;
    font-size: 20px;
    font-weight: 550;
    padding-left: 30px;
    padding-right: 10px;
`


const HorizontalSprator = styled.div`
    background-color: #58AC65;
    height: 1px;
`

const Total = styled.div`
    background-color: rgba(88, 172, 101, 0.2);
    padding: 12px 20px;
    font-size: 20px;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    border-radius: 20px;
`

const Button = styled.button`
    background: #007912;
    border-radius: 12px;
    border: none;
    padding:12px;
    width: 100%;
    color: #FFF;
    font-size: 20px;
    font-weight: 700;
    animation: slideUp;
    animation-duration: 0.5s;
    cursor: pointer;
`

export default Cart;